<template>
    <div class="housekeeping-card">
		<div class="details">
			<v-btn
				v-if="!reservationState"
				class="state"
				:to="href"
				icon>
				<p class="text-observed" v-if="flagObserved">Observado</p>
				<img :src="`${$imageS3}/clerkinn/${image}-icon.svg`">
			</v-btn>
			<v-btn
				v-else
				class="state"
				:to="href"
				icon>
				<p class="text-observed" v-if="flagObserved">Observado</p>
				<span class="bar-caption-icon booking">
					R
				</span>
			</v-btn>
			<router-link :to="href" class="room">
				{{ roomNumber }}
				<span class="dsq">{{ roomTypeCode }}</span>
			</router-link>
			<div
				class="triangle-left"
				:style="`border-left: 30px solid ${bookingColor}; border-top: 30px solid ${bookingColor};`">
			</div>
		</div>
		<div class="info-details">
			<p
				class="name"
				text-xs-center
				v-tooltip:left="{ html: fullName }"
			>
				{{ fullName | truncate }}
			</p>
			<v-layout justify class="divider">
				<v-flex class="date" md6 text-xs-left>
					<span>{{ startDate | parseDate('DD/MM') }} - {{ endDate | parseDate('DD/MM') }}</span>
				</v-flex>
				<v-flex class="price" md6 text-xs-right>
					<span>{{ currency }} {{ bookingTotal | round }}</span>
				</v-flex>
			</v-layout>
		</div>	
    </div>
</template>
<script>
import { parseDate, round, truncate } from '@/shared/filters';

function fullName() {
	return `${this.lastname} ${this.name}`;
}

function image() {
	let icon = '';
	if (this.bookingState === 2) {
		icon = 'checkin';
	} else if (this.bookingState === 3) {
		icon = 'checkout';
	} else if (this.bookingState === 6) {
		icon = 'no-show';
	} else if (this.bookingState === 7) {
		icon = 'in-house';
	}
	return icon;
}

function reservationState() {
	return this.bookingState === 1;
}

export default {
	name: 'housekeeping-card',
	computed: {
		fullName,
		image,
		reservationState,
	},
	filters: {
		parseDate,
		round,
		truncate,
	},
	props: {
		flagObserved: {
			type: Boolean,
			required: true,
			default: null,
		},
		roomNumber: {
			type: Number,
			required: true,
			default: null,
		},
		roomTypeCode: {
			type: String,
			required: true,
			default: '',
		},
		lastname: {
			type: String,
			required: true,
			default: '',
		},
		name: {
			type: String,
			required: true,
			default: '',
		},
		startDate: {
			type: String,
			required: true,
			default: '',
		},
		endDate: {
			type: String,
			required: true,
			default: '',
		},
		currency: {
			type: String,
			required: true,
			default: '',
		},
		bookingTotal: {
			type: [Number, String],
			required: true,
			default: 0,
		},
		bookingColor: {
			type: String,
			required: true,
			default: 'transparent',
		},
		bookingState: {
			default: 1,
			type: Number,
		},
		href: {
			default: '/dashboard',
			type: [String, Object],
		},
	},
};
</script>
<style lang="scss" scoped>
	.text-observed {
		color: #ffe955;
		font-family: map-get($map: $fonts, $key: regular);
		font-size: 12px;
		position: relative;
		right: 10px;
		top: 7px;
	}
	
    .housekeeping-card {  
		align-items: center;
		box-shadow: 0 4px 9px 0 rgba(0, 0, 0, 0.13);   
		display: inline-flex;
    height: 102px;
		margin-bottom: 19px;
		margin-left: 15px;
		min-width: 179px;
		position: relative;
		width: 179px;

		.details {
			left: 0;
			position: absolute;
			right: 0;
			top: 0;
			img {
				right: 0;
			}
		}

		.info-details {
			position: relative;
			width: 100%;
		}

		.state {
			height: auto;
			min-width: auto;
			padding: 5px;
			position: absolute;
			right: 0;
			width: auto;
		}

		.room {
			color: map-get($colors, white-bond);
			font-family: map-get($map: $fonts, $key: medium);
			height: 16px;
			left: 7px;
			position: absolute;
			
			.dsq {
				display: block;
				font-size: map-get($map: $sizes, $key: ten);
				height: 12px;
				margin-top: -5px;
				width: 19px;
			}

			img {
				right: 0;
			}
		}

        .triangle-left {
            border-bottom: 30px solid transparent;
            border-right: 30px solid transparent;
            height: 0;
            width: 0;
        }

		.name {
			color: map-get($colors, bg-chart);
			font-family: map-get($map: $fonts, $key: semibold);
			font-size: map-get($map: $sizes, $key: twelve);
			height: 28px;
			letter-spacing: normal;
			line-height: normal;
			max-width: 100px;
			margin: auto;
			text-align: center;
		}

		.date , .price {
			color: #828282;
			height: 14px;
			font-size: 12px;
			font-stretch: normal;
			font-style: normal;
			font-weight: normal;
			letter-spacing: normal;
			line-height: normal;
			text-align: left;
			width: 67px;
		}

		.divider {
			background: transparent;
			border-top: 1px dashed map-get($colors, divider);
			bottom: -13px;
			left: 3px;
			position: absolute;
			right: 0;
		}
	}
	
	.bar-caption-icon.booking {
		background-color: map-get($colors, booking);
		border-radius: 50%;
		color: map-get($colors, white);
		display: inline-block;
		height: 14px;
		line-height: 14px;
		text-align: center;
		width: 14px;
	}
</style>





// WEBPACK FOOTER //
// HousekeepingCard.vue?6eb95671